import axios from 'axios';
import routes from 'app/routes';

export default {
  create: (enterpriseId, params, onSuccess, onError) => {
    axios
      .post(routes.api.enterprise_briefs.create, {
        enterprise_id: enterpriseId,
        ...params,
      })
      .then(() => {
        onSuccess();
      })
      .catch((error) => {
        onError(error.response.data.errors);
      });
  },

  update: (enterpriseBriefId, params, onSuccess, onError) => {
    axios
      .put(routes.api.enterprise_briefs.update(enterpriseBriefId), params)
      .then(() => {
        onSuccess();
      })
      .catch((error) => {
        onError(error.response.data.errors);
      });
  },

  delete: (enterpriseBriefId, onSuccess) => {
    axios
      .delete(routes.api.enterprise_briefs.destroy(enterpriseBriefId))
      .then((_resp) => {
        onSuccess(enterpriseBriefId);
      });
  },
};
